export const API_BASE = '/api/astro-annotate';
export const API_ANNOTATIONS = `${API_BASE}/annotations`;

export const SHADOW_ROOT_ID = 'astro-annotate-root';
export const CSS_PREFIX = 'aa-';

export const DEFAULT_ANNOTATIONS_PATH = './annotations.json';
export const ANNOTATIONS_VERSION = '0.1';

export const VIRTUAL_MODULE_ID = 'virtual:astro-annotate/config';
export const RESOLVED_VIRTUAL_MODULE_ID = '\0' + VIRTUAL_MODULE_ID;
